import {
  Component,
  ComponentRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {Subject} from 'rxjs';
import {distinctUntilChanged, filter, takeUntil, tap} from 'rxjs/operators';
import {DynamicComponentBaseComponent} from '../../../dynamic-components/components/dynamic-component-base/dynamic-component-base.component';
import {GenericFieldDirective} from '../../directives/generic-field/generic-field.directive';
import {FieldColumns} from '../../enums/field-columns';
import {DynamicFormElementEl} from '../../interfaces/fields-components';
import {FormAllData, FormParts} from '../../interfaces/forms/form-element';
import {FieldService} from '../../services/field/field.service';
import {FormService} from './../../services/form/form.service';

@Component({
    selector: 'app-form',
    templateUrl: './form.component.html',
    styleUrls: ['./form.component.scss'],
    standalone: false
})
export class FormComponent extends DynamicComponentBaseComponent implements OnInit, OnDestroy {
  // @Input() formData!: FormParts;
  // @Input() formGroup!: FormGroup;

  @Input() override data!: DynamicFormElementEl & {
    formData: FormParts<FormAllData>;
  };

  private destroy$: Subject<boolean> = new Subject<boolean>();

  @Input() isStep = false;
  @Input() isLastStep = false;

  @Input() submitButtonStyle = {} as {text: string; blockStyle?: boolean};
  @Output() stepClick: EventEmitter<number> = new EventEmitter<number>();
  @Output() additionaButtonEvent: EventEmitter<unknown> = new EventEmitter<unknown>();
  @Output() createdComponents: EventEmitter<unknown[]> = new EventEmitter();

  defaultColumn = FieldColumns.HALF;

  private componentList: unknown[] = [];

  hasRequiredError = false;
  hasFillError = false;
  counter = 0;

  constructor(
    private fieldService: FieldService,
    private formService: FormService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.notRendenderedFields(this.data.formData.form);
  }
  notRendenderedFields(form: FormAllData[]) {
    form.forEach((el: FormAllData) => {
      this.fieldService
        .getParams(el.name ?? el.id, this.data.stepName)
        .pipe(
          distinctUntilChanged(),
          filter((elAfter: FormAllData) => {
            return el.hidden || elAfter.hidden || false;
          }),
          tap((elPart: FormAllData) => {
            (<(keyof FormAllData)[]>Object.keys(elPart)).forEach((key) => {
              (<any>el[key]) = elPart[key];
            });

            if (
              el.name &&
              typeof elPart.hidden !== 'undefined' &&
              !elPart.hidden &&
              !this.data.formGroup.get(el.name)
            ) {
              const fc = this.formService.AddFormField(el);
              this.data.formGroup.addControl(el.name, fc, {emitEvent: false});
              // hiddenField.unsubscribe();
            }
          }),
          takeUntil(this.destroy$),
        )
        .subscribe();
    });
  }

  onNextStep(_evt: MouseEvent) {
    if (this.isStep && !this.isLastStep) {
      this.stepClick.emit(1);
    }
  }

  onAdditionalButtonClick(event: any) {
    this.additionaButtonEvent.emit(event);
  }
  onCreatedComponent(evt: unknown) {
    this.componentList.push(evt);
    if (this.data.formData.form.length === this.componentList.length) {
      this.createdComponents.emit(this.componentList);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
